<template>
  <div
    class="bets-container">
    <div class="bets-tabs">
      <div
        v-bind:class="[{'bets-tabs-active':activeBetSection === 'bettingBot'},{'bet-tab--disabled':isPlacingBets}]"
        class="bets-tab"
        @click="selectTraderSection('bettingBot')">
        <div class="bets-text">
          <span>{{ $t('trader.bettingBotTab')}}</span>
        </div>
        <div class="bets-tab-bottom-bar">
        </div>
      </div>
      <div
        v-bind:class="[{'bets-tabs-active':activeBetSection === 'ticker'},{'bet-tab--disabled':isPlacingBets}]"
        class="bets-tab"
        @click="selectTraderSection('ticker')">
        <div class="bets-text trader-container">
          <span>{{ $t('trader.tickerTab')}}</span>
          <template  v-if="activeBetSection === 'ticker'">
            <v-icon @click.self="toggleTicker" v-if="isFrozen" >krypt-play</v-icon>
            <v-icon @click.self="toggleTicker" v-if="!isFrozen" >krypt-pause</v-icon>
          </template>
        </div>
        <div class="bets-tab-bottom-bar">
        </div>
      </div>
      <div
        v-bind:class="[{'bets-tabs-active':activeBetSection === 'settled'},{'bet-tab--disabled':isPlacingBets}]"
        class="bets-tab"
        @click="selectTraderSection('settled')">
        <div class="bets-text">
          <span>{{ $t('trader.settledMarketsTab')}}</span>
        </div>

        <div class="bets-tab-bottom-bar">
        </div>
      </div>
      <div class="bets-tab management-console-open" @click="openManagementConsole">
        <div class="bets-text">
          <span><v-icon>krypt-launch</v-icon></span>
        </div>
      </div>
    </div>
    <transition name="slide">
      <div v-if="bettingBotMessage.message !=''" class="bets-top-alert" v-bind:class="[{
      'error-message':bettingBotMessage.type==='error',
      'success-message':bettingBotMessage.type==='success',
      'warning-message':bettingBotMessage.type==='warning',
      }]">
        <span>{{bettingBotMessage.message}}</span>
      </div>
    </transition>
    <div id="bets-container">
      <SettledMarkets v-if="activeBetSection === 'settled'"></SettledMarkets>
      <Ticker v-if="activeBetSection === 'ticker'"></Ticker>
      <BettingBot v-if="activeBetSection === 'bettingBot'"></BettingBot>
    </div>
  </div>
</template>

<script>

import KryptButton from "@/components/other/kryptButton";
import BettingBot from "@/components/views/BettingBot";
import SettledMarkets from "@/components/views/SettledMarkets";
import Ticker from "@/components/views/Ticker";

export default {
  data: function (){
    return {
      tickerRunning:true
    }
  },
  computed:{

    isPlacingBets:function(){
      return this.$store.state.bets.betslip.isPlacingBets;
    },
    activeBetSection:function () {
      return this.$store.state.trader.activeSection;
    },
    bettingBotMessage:function () {
      return this.$store.state.trader.bettingBot.message;
    },
    isFrozen:function () {
      return this.$store.state.trader.ticker.tickerIsFrozen;
    },
    tickerBetsOnHold:function () {
      return this.$store.state.trader.ticker.tickerBetsOnHold;
    },
    user:function (){
      return this.$store.state.user
    }
  },
  methods:{
    pauseTicker:function(){
      this.$store.commit('setTickerIsFrozen',true)
    },
    unPauseTicker:function(){
      this.$store.commit('setTickerIsFrozen',false)

    },
    selectTraderSection:function(section){
      if(!this.isPlacingBets) this.$store.commit('setTraderActiveSection',section)
    },
    toggleTicker:function (){
      if(this.isFrozen===true) this.$store.commit('moveOnHoldBetsToActiveTickerFeed');
      this.$store.commit('setTickerIsFrozen',!this.isFrozen);


      // this.tickerRunning = !this.tickerRunning;
    },
    openManagementConsole:function (){
      console.log(process.env.VUE_APP_BACKEND_URL);
      window.open(`${process.env.VUE_APP_BACKEND_URL}/console?token=${this.user.token}`, '_blank').focus();
    }
  },
  components:{
    BettingBot,
    KryptButton,
    SettledMarkets,
    Ticker
  },
  name: 'TraderBets'
};
</script>

<style scoped>
  .krypt-play:focus::after {
    opacity: 0;
  }
  .krypt-pause:focus::after {
    opacity: 0;
  }
  .krypt-play{
    padding-left: 4px;
    color: var(--grey-400);
  }
  .krypt-pause{
    padding-left: 4px;
    color: var(--grey-400);
  }
  .krypt-play:hover{
    color: var(--grey-600);
  }
  .krypt-pause:hover{
    color: var(--grey-600);
  }
  .loading-settled-bets{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
  }

  .loading-settled-bets-text{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .loading-settled-bets-text > span{
    font-size: 14px;
    line-height: 16px;
    color: var(--grey-400);
    padding-left: 8px;
  }

  .bets-container{
    width: 360px;
    height: 100%;
    overflow: auto;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    z-index: 0;
  }

  #bets-container{
    overflow: auto;
    display: flex;
    flex-grow: 1;
    width: 100%;
    position: relative;
    overscroll-behavior: contain;
  }

  .bets-tabs{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100% ;
    cursor: pointer;
    background-color: var(--grey-100);
  }

  .bets-tabs-active{
    background-color: white !important;
  }

  .bets-tab{
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%;
    height: 48px; /* can't avoid hard-coding height because indicator is not always there and text might wrap */
    padding: 8px; /* so that nothing hits the edges */
    overflow: hidden;
  }

  .bets-text{
    /* padding-top: 15px; - removing because it increases height when the header text wraps */
    /* padding-right: 4px; - removing because it doesn't allow proper centre alignment */
    /* padding-bottom: 17px; - removing because it increases height when the header text wraps */
    max-height: 32px;
    overflow: hidden;
  }

  .bets-text > span{
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    line-height: 16px;
    font-size: 12px;
    font-weight: 700;
    color: var(--grey-400);
    user-select: none;
    width: min-content;
  }

  .bets-tab:not(.bets-tabs-active):hover .bets-text > span {
    color: var(--grey-600);
  }

  .bets-tabs-active .bets-text > span{
    color: var(--grey-900) !important;
  }

  .bets-umatched-indicator{
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--cyborg);
    border-radius: 16px;
  }
  .bets-indicator{
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--primary);
    border-radius: 16px;
  }
  .bets-tabs-active .bets-tab-count{
    /*background-color: var(--primary);*/
  }

  .bets-tab-count > span{
    display: flex;
    align-items: center;
    text-align: center;
    user-select: none;
    line-height: 14px;
    color: white;
    font-size: 10px;
    font-weight: 700;
    padding: 2px 4px;
  }

  .bets-tab-count {
    min-width: 20px;
    margin-left: 4px;
  }

  .bets-tab-bottom-bar{
    display: flex;
    position: absolute;
    width: 100%;
    border-radius: 17px;
    background-color: transparent;
    padding: 2px 0;
    bottom: 0;
  }


  .bets-tabs-active .bets-tab-bottom-bar{
    background-color: var(--primary) !important;
  }

  .bets-top-alert{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    max-height: 73px;
    clip-path: inset(0%);
    transition: max-height 0.5s ease-in-out;
  }

  .bets-top-alert > span{
    padding: 8px 8px;
    font-weight: bold;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
    height: max-content;
    text-align: center;
    /*color: var(--cyborg);*/
  }
  .error-message > span{

    background-color: var(--cyborg-light);
    color: var(--cyborg);
  }
  .success-message > span{
    background-color:var(--aquaman-light);
    color: var(--aquaman);
  }
  .warning-message > span{
    background-color: var(--wonder-woman-light);

    color: var(--wonder-woman);
  }
  .slide-enter-active, .slide-leave-active {
    transition: max-height 0.5s ease-in-out;
  }

  .slide-enter, .slide-leave-to {
    max-height: 0px;
  }
  .bet-tab--disabled{
    /*opacity: 0.6;*/
    cursor: not-allowed;
  }

  .trader-container{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .trader-container img{
    padding-left: 4px;
    filter: invert(63%) sepia(6%) hue-rotate(158deg);
    transition: all 0.4s ease-in-out;
  }

  .trader-container img:hover{
    filter: invert(45%) sepia(14%) hue-rotate(144deg);
  }
  
  .bets-tab.management-console-open {
    width: 30%;
  }
  
  .bets-tab.management-console-open .bets-text > span .v-icon,
  .bets-tab.management-console-open:hover .bets-text > span .v-icon {
    color: inherit;
  }
    
  /*Media Queries*/

  @media screen and (max-width: 1279px) {
    .bets-container{
      width: 100%!important;
    }
  }
</style>
